import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLsicLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 300,
	height: 300,
	viewBox: "0 0 300 300",
	fill: "#293B51",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M150 300C232.843 300 300 232.843 300 150C300 67.1573 232.843 0 150 0C67.1573 0 0 67.1573 0 150C0 232.843 67.1573 300 150 300Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M130.458 102.86V161.193C139.667 161.193 147.125 153.735 147.125 144.527V86.1934C137.917 86.1934 130.458 93.6517 130.458 102.86Z",
			fill: "#293B51"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.6667 144.527V102.86C85.6667 93.6517 78.2083 86.1934 69 86.1934V161.193H123.167L113.542 144.527H85.6667Z",
			fill: "#293B51"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M192.958 86.1934C172.25 86.1934 155.458 102.985 155.458 123.693C155.458 144.402 172.25 161.193 192.958 161.193C213.667 161.193 230.458 144.402 230.458 123.693C230.458 102.985 213.667 86.1934 192.958 86.1934ZM192.958 144.527C181.469 144.527 172.125 135.183 172.125 123.693C172.125 112.204 181.469 102.86 192.958 102.86C204.448 102.86 213.792 112.204 213.792 123.693C213.792 135.183 204.448 144.527 192.958 144.527Z",
			fill: "#293B51"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M231.904 195.774L238.478 185.818H244.748L234.564 200.182V212H229.282V200.106L219.136 185.818H225.444L231.904 195.774Z",
			fill: "#293B51"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M199.125 185.818H218.847V190.492H211.627V212H206.345V190.492H199.125V185.818Z",
			fill: "#293B51"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M191.077 185.818V207.326H200.995V212H185.795V185.818H191.077Z",
			fill: "#293B51"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M183.161 212H177.613L175.485 205.73H165.681L163.591 212H157.967L167.733 185.818H173.433L183.161 212ZM170.583 191.214L167.239 201.132H173.927L170.583 191.214Z",
			fill: "#293B51"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M155.358 212H150.076V185.818H155.358V212Z",
			fill: "#293B51"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.59 212.456C128.18 212.456 122.29 206.338 122.29 198.89C122.29 191.518 128.18 185.362 135.59 185.362C140.036 185.362 143.912 187.49 146.268 190.796L142.24 193.722C140.758 191.632 138.554 190.34 135.78 190.34C131.03 190.34 127.572 194.216 127.572 198.89C127.572 203.564 130.992 207.478 135.742 207.478C138.554 207.478 140.758 206.186 142.24 204.096L146.268 207.022C143.912 210.328 140.036 212.456 135.59 212.456Z",
			fill: "#293B51"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M108.284 201.474V207.326H119.76V212H103.002V185.818H119.418V190.492H108.284V196.724H118.05V201.474H108.284Z",
			fill: "#293B51"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.9292 185.818H90.6072C96.5352 185.818 99.1572 190.074 99.1572 194.368C99.1572 198.662 96.5352 202.842 90.6072 202.842H85.2112V212H79.9292V185.818ZM85.2112 198.206H90.3412C92.8872 198.206 93.8372 196.23 93.8372 194.368C93.8372 192.468 92.8872 190.492 90.4172 190.492H85.2112V198.206Z",
			fill: "#293B51"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.1341 212.456C60.5481 212.456 56.7101 208.998 56.7101 204.4H61.9921C62.0301 206.262 63.8541 207.82 66.2861 207.82C68.6421 207.82 70.2001 206.528 70.2001 204.666C70.2001 203.222 69.1361 202.196 66.8941 201.512L63.7021 200.6C57.9641 199.08 56.9381 195.622 56.9381 193.266C56.9381 188.592 60.9661 185.362 65.9821 185.362C70.9221 185.362 74.7221 188.364 74.7221 193.342H69.4401C69.4401 191.48 68.1481 190.036 65.8681 190.036C63.8161 190.036 62.2581 191.404 62.2581 193.152C62.2581 193.798 62.4481 195.128 65.1841 195.926L68.1101 196.762C72.0621 197.94 75.5201 199.954 75.5201 204.4C75.5201 209.606 71.0741 212.456 66.1341 212.456Z",
			fill: "#293B51"
		})
	]
});
export default SvgLsicLogo;
